import { ColorHex } from '../../components/ProfileIcon/types';

export default (colorHex: string): ColorHex => {
  // Remove any leading '#' from the color input
  const color = colorHex.replace('#', '');

  // Convert the color input to RGB format
  const r = parseInt(color.substr(0, 2), 16);
  const g = parseInt(color.substr(2, 2), 16);
  const b = parseInt(color.substr(4, 2), 16);

  // Calculate the relative luminance using the formula from WCAG 2.0
  const relativeLuminance = (r * 0.299 + g * 0.587 + b * 0.114) / 255;

  // Check if the relative luminance indicates a dark or light color
  if (relativeLuminance > 0.5) {
    // Light color, return black text
    return '#000';
  }
  // Dark color, return white text
  return '#fff';
};
